import { isValidElement } from "react"
import { useTranslation } from "react-i18next"
import { Grid, Typography } from "@mui/material"

import type { DetailsGroup } from "types/common.types"

import CardWithTitle from "widgets/common/CardWithTitle"
import LabelValueStack from "widgets/common/LabelValueStack"

interface DetailsGroupsCardProps {
  titleKey: string
  groups: DetailsGroup[]
}

/** A read-only card of labelled values, split into columns by group. */
const DetailsGroupsCard = ({ titleKey, groups }: DetailsGroupsCardProps) => {
  const { t } = useTranslation()

  return (
    <CardWithTitle titleKey={titleKey}>
      <Grid container columnSpacing={4} rowSpacing={3}>
        {groups.map(({ titleKey, fields }) => (
          <Grid item xs={12} md={4} key={titleKey}>
            <Typography variant="overlineDense" component="p" sx={{ mb: 2 }}>
              {t(titleKey)}
            </Typography>
            {fields.map(({ labelKey, value, tooltipContent }) => (
              <LabelValueStack
                key={labelKey}
                labelKey={labelKey}
                value={
                  // Links pass through, plain values are muted in grey.
                  isValidElement(value) ? (
                    value
                  ) : (
                    <Typography color="neutral.600">{value ?? "-"}</Typography>
                  )
                }
                tooltipContent={tooltipContent}
              />
            ))}
          </Grid>
        ))}
      </Grid>
    </CardWithTitle>
  )
}

export default DetailsGroupsCard
